declare global {
  interface Window {
    __RUNTIME_CONFIG__?: {
      SITE_NAME?: string;
      API_URL?: string;
      API_HOST?: string;
      FRONTEND_URL?: string;
      BASE_PATH?: string;
    };
  }
}

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

const runtime = window.__RUNTIME_CONFIG__ ?? {};

export const config = {
  siteName: runtime.SITE_NAME || "Marmoreal",
  apiUrl: runtime.API_URL
    ? trimTrailingSlash(runtime.API_URL)
    : `${window.location.origin}/api`,
  apiHost: runtime.API_HOST
    ? trimTrailingSlash(runtime.API_HOST)
    : window.location.origin,
  frontendUrl: runtime.FRONTEND_URL
    ? trimTrailingSlash(runtime.FRONTEND_URL)
    : window.location.origin,
  basePath: runtime.BASE_PATH || "/",
};
